export const getAdPreviewGridLayoutStyles = (/* components, { palette = {} } = {} */) => ({
  adPreviewGridLayoutContainer: {
    display: 'grid',
  },
});
